import SliderNextArrow from '@components/common/slider/SliderNextArrow';
import SliderPrevArrow from '@components/common/slider/SliderPrevArrow';
import React from 'react';
import { CheckboxFieldType, FormFieldType } from '@/type';

export const terminalPreviewSliderSettings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  arrows: true,
  nextArrow: <SliderNextArrow />,
  prevArrow: <SliderPrevArrow />,
};

export const checkBoxFormField: CheckboxFieldType = {
  name: 'isBlackAndWhiteCheckBox',
  label: 'common.black-and-white',
  type: FormFieldType.Checkbox,
};
